module.exports = __webpack_public_path__ + "img/certificado-mobile.f02ed86d.png";